/**
 * Hook chamado UMA vez pelo app-core (`ui/modules.tsx`): liga o carregamento
 * e adiciona as duas camadas (pontos e modelo) ao mapa quando ele existir.
 */
import { createElement, useEffect } from 'react';
import { useMapInstance } from '../map/mapContext';
import { ArPopup } from './ArPopup';
import { CamsPopup } from './CamsPopup';
import { createArLayers } from './layer';
import { iniciarSyncAr } from './sync';

export { refreshAr } from './sync';

export function useArLayers(): void {
  const map = useMapInstance((s) => s.map);

  useEffect(() => iniciarSyncAr(), []);

  useEffect(() => {
    if (!map) return;
    const { pontos, modelo, destaque, dispose } = createArLayers(
      (dado) => createElement(ArPopup, { dado }),
      (indice) => createElement(CamsPopup, { indice }),
    );
    map.addLayer(modelo);
    map.addLayer(destaque);
    map.addLayer(pontos);
    return () => {
      map.removeLayer(pontos);
      map.removeLayer(destaque);
      map.removeLayer(modelo);
      dispose();
    };
  }, [map]);
}
